import React from 'react';
import PropTypes from 'prop-types';
import TextField from './text_field';
const EmailFormat = /(.+)@(.+){2,}\.(.+){2,}/;
class EmailField extends TextField {
  constructor(props) {
    super(props);
    this.fieldType = 'email';
    this.validations.push(this.validateEmailFormat);
  }
  validateEmailFormat(value) {
    if (!EmailFormat.test(value)) {
      return 'Email is formatted incorrectly';
    }
  }
}
EmailField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
export default EmailField;
